// Actions
const PREFIX = 'calculus/info/';

export const SHOW_INFO_SCREEN  = PREFIX + 'SHOW_INFO_SCREEN';
export const HIDE_INFO_SCREEN  = PREFIX + 'HIDE_INFO_SCREEN';

const INITIAL_STATE = {
  visible: false,
  message: null
};

// Reducer
export default function reducer(state = INITIAL_STATE, action = {}) {
  const { type, payload } = action;

  switch (type) {

    case SHOW_INFO_SCREEN:
      return {
        ...state,
        visible: true,
        message: payload
      };

    case HIDE_INFO_SCREEN:
      return {
        ...state,
        visible: false,
        message: null
      };

    default:
      return state;
  }
}

export function showInfoScreen(payload) {
  return {
    type: SHOW_INFO_SCREEN,
    payload: payload
  };
}

export function hideInfoScreen() {
  return {
    type: HIDE_INFO_SCREEN,
  };
}
